module.exports = __webpack_public_path__ + "static/contact-9ba313999b171f36f6881036fbf7a2f8.svg";